"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_224)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_224`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V23.9998H0V0.000244141Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H36V4.79999H0V0.000244141ZM0 19.2H36V23.9998H0V19.2ZM0 9.59974H36V14.3995H0V9.59974Z",
					fill: "#496E2D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0.000244141H14.3476V14.3478H0V0.000244141Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.17371 3.41748L8.10605 6.28708H11.1236L8.68247 8.06078L9.61482 10.9305L7.17371 9.15695L4.73252 10.9305L5.66508 8.06078L3.22397 6.28708H6.24129L7.17371 3.41748Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_224`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TGFlag };
